module.exports = __webpack_public_path__ + "static/media/p005.b39b7b30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/p005.jpg
// module id = 1518
// module chunks = 0